import Vue from 'vue'

export default Vue.extend({
  name: 'ReportMixin',
  data() {
    return {
      optsGroupTime: [
        { text: '1 minute', value: '1m' },
        { text: '1 hour', value: '1h' },
        { text: '1 day', value: '1d' },
      ],
    }
  },
})
